'use client'

import { BaseDialog, Folder, useDeleteFolder } from '@/dc-shared-web/src'
import { Button } from '@dc-shared-web/components/shadcn/button'
import { FoldersListItem } from '@/dc-shared-web/src/hooks/api/folder/types'
export function DeleteFolderDialog({
  folder,
  onDialogClose,
  onDeleteSuccess,
  teamUuid,
}: {
  folder: Folder | FoldersListItem
  onDialogClose: () => void
  onDeleteSuccess: () => void
  teamUuid?: string
}) {
  const { mutate: deleteFolder, isLoading: isDeletingFolder } =
    useDeleteFolder()

  const onDeleteSubmit = async () => {
    await deleteFolder({
      folderUuid: folder.uuid,
      office_uuid: teamUuid,
      name: folder.name,
    })
    onDeleteSuccess()
    onDialogClose()
  }

  return (
    <BaseDialog
      title='Delete folder'
      isOpen
      onClose={onDialogClose}
      primaryActionSlot={
        <Button
          onClick={onDeleteSubmit}
          variant={'destructive'}
          type='submit'
          disabled={isDeletingFolder}
          data-testid='delete-folder-dashboard-trigger'
        >
          {isDeletingFolder ? 'Deleting...' : 'Yes, Delete'}
        </Button>
      }
    >
      <p className='tw-text-sm'>
        Are you sure you want to delete &quot;{folder.name}&quot;?
      </p>
    </BaseDialog>
  )
}
